import React from 'react'
import Header from './Components/Header/Header'
import SectionThree from './Components/SectionThree/SectionThree'
import SectionTow from './Components/SectionTwo/SectionTow'
const Works = () => {
  return (
    <div>
        <Header />
        <SectionTow />
        <SectionThree />
    </div>
  )
}

export default Works